// hooks/useUserSourceDetails.js
import { useCallback, useState } from "react";
import { apiFetchSourceUserDetailsById } from "../../api/backend/user";
import { isSuspendedFrom } from "../../utils/membersSiteAccessPermissions";

export const useUserSourceDetails = () => {
  const [sourceUserAcctDetails, setSourceUserAcctDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getSourceAccountHolderDetailsById = useCallback(async (userId) => {
    setLoading(true);
    try {
      const res = await apiFetchSourceUserDetailsById(userId);

      if (isSuspendedFrom(res) || isSuspendedFrom(res?.data)) {
        return { __eject: true };
      }
      setSourceUserAcctDetails(res.data);
      setError(null);
      return res.data; // important: give callers the details
    } catch (err) {
      console.error(
        `Failed to fetch account holder details for ID: ${userId}`,
        err
      );
      setError(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    sourceUserAcctDetails,
    loading,
    error,
    getSourceAccountHolderDetailsById,
  };
};
